<ng-container *ngIf="displayData">
  <section class="capital-information-section">
    <h2 class="section-title-with-icon">
      <!-- monetization_on -->
      <mat-icon svgIcon="capital_info" class="section-title-icon notranslate"></mat-icon>
      <span>Capital Information</span>
    </h2>
    <ul class="details-list">
      <!-- Total Shares -->
      <li *ngIf="!!holding.totalShares">
        <label>Total Shares</label>
        <span>
          <span class="value">{{ holding.totalShares | terraCurrency }} </span>
        </span>
      </li>
      <!-- Total capitalization -->
      <li *ngIf="holding.totalCapitalization != undefined">
        <label *ngIf="holdingDiscriminator === HoldingDiscriminator.Fund">Capitalization at Inception</label>
        <label *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset">
          {{ holdingAsAsset.initialSecurityType === SecurityType.Debt ? 'Total Loan' : 'Capitalization at Inception'}}
        </label>
        <span>
          <span class="value">{{ holding.totalCapitalization | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
      <!-- Loan amount (opens dialog) -->
      <li *ngIf="holding.lenderInformation?.amount">
        <label>
          <a class="light link" (click)="showLenderInfoDialog(holding.lenderInformation, holding.initialCurrency,
          holding.estimatedMarketValue, holding.projectBudgetOriginal?.totalCosts)">
            {{holding.discriminator === HoldingDiscriminator.Fund ? 'Loan Amount' :
              holdingAsAsset.initialSecurityType === SecurityType.Debt ? 'Senior Loan' : 'Loan Amount'}}
          </a>
        </label>
        <span>
          <span class="value">{{ holding.lenderInformation.amount | terraCurrency }} </span>
          <span class="unit">
            {{ holding.initialCurrency.iso }}
            <ng-container *ngIf="holding.lenderInformation?.loanToValue">
              ({{ holding.lenderInformation.loanToValue }}%)
            </ng-container>
          </span>
        </span>
      </li>

      <!-- Junior Loan amount (opens dialog) -->
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holding.lenderInformation?.amountJunior">
        <label>
          <a class="light link" (click)="showLenderJuniorInfoDialog(holding.lenderInformation, holding.initialCurrency,
          holding.estimatedMarketValue, holding.projectBudgetOriginal?.totalCosts)">Junior Loan</a>
        </label>
        <span>
          <span class="value">{{ holding.lenderInformation.amountJunior | terraCurrency }} </span>
          <span class="unit">
            {{ holding.initialCurrency.iso }}
            <ng-container *ngIf="holding.lenderInformation?.loanToValueJunior">
              ({{holding.lenderInformation.loanToValueJunior}}%)
            </ng-container>
          </span>
        </span>
      </li>

      <!-- Total investor equity -->
      <li *ngIf="holding.totalInvestorEquity > 100">
        <label>Total Investor Equity</label>
        <span>
          <span class="value">{{ holding.totalInvestorEquity | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>

      <!-- GP equity from total equity -->
      <li *ngIf="holding.gpEquityFromTotalEquity != undefined">
        <label *ngIf="holding.discriminator === HoldingDiscriminator.Fund">GP Equity from Total Equity</label>
        <label *ngIf="holding.discriminator === HoldingDiscriminator.Asset">
          {{ holdingAsAsset.initialSecurityType === SecurityType.Debt ? 'GP Share of the Loan' : 'GP Equity from Total Equity'}}
        </label>
        <span>
          <span class="value">{{ holding.gpEquityFromTotalEquity | terraNumber }}</span>
          <span class="unit">%</span>
        </span>
      </li>

      <!-- Total equity invested to date -->
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holding.totalEquityInvestedToDate != undefined">
        <label>Total Equity Invested to Date</label>
        <span>
          <span class="value">{{ holding.totalEquityInvestedToDate | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>

      <!-- Total returns to date -->
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holding.totalReturnsToDate != undefined">
        <label>Total Returns to Date</label>
        <span>
          <span class="value">{{ holding.totalReturnsToDate | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>

      <!-- Estimated market value -->
      <li *ngIf="holding.estimatedMarketValue != undefined" >
        <span>
          <label>Estimated Market Value</label>
          <mat-icon
            matTooltip="Investment Values are derived using market-based valuation techniques such as the direct capitalization method, bona fide purchase offers, and independent appraisals. Although the fair values utilize certain unobserved market inputs and estimates, management believes the value is a reasonable approximation of market pricing. Such assessments are identified for investment and portfolio management purposes only and do not represent a liquid value."
            class="notranslate list-item-tooltip" color="primary" matTooltipClass="terra-tooltip"
            matTooltipPosition="right">help
          </mat-icon>
        </span>
        <span>
          <span class="value">{{ holding.estimatedMarketValue | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>

      <!-- Revised project budget -->
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holdingAsAsset.actualCostsToDate != undefined">
        <label>Revised Project Budget</label>
        <span>
          <span class="value">{{ holdingAsAsset.actualCostsToDate | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>

      <!-- Outstanding loan amount to date -->
      <li *ngIf="holding.discriminator === HoldingDiscriminator.Asset && holdingAsAsset.initialSecurityType === SecurityType.Debt &&
                 holdingAsAsset.outstandingLoanAmountToDate !== null && holdingAsAsset.outstandingLoanAmountToDate !== undefined">
        <label>Outstanding Loan Amount to Date</label>
        <span>
          <span class="value">{{ holdingAsAsset.outstandingLoanAmountToDate | terraCurrency }} </span>
          <span class="unit">
            {{ holdingAsAsset.initialCurrency.iso }}
            @if (holdingAsAsset.lenderInformation.amount !== null && 
                holdingAsAsset.lenderInformation.amount !== undefined &&
                holdingAsAsset.totalInvestorEquity !== null &&
                holdingAsAsset.totalInvestorEquity !== undefined) {
              <span>
                ({{100 * holdingAsAsset.outstandingLoanAmountToDate / (holdingAsAsset.lenderInformation.amount + holdingAsAsset.totalInvestorEquity) | number:'1.0-1'}}%)
              </span>
            }
          </span>
        </span>
      </li>

      <!-- Capital Returned  -->
       @if(holdingAsAsset.totalInvestorEquity > 100){
        <li>
          <label>Capital Returned</label>
          <span>
            <span class="value">{{ holding.totalCapitalReturned | terraCurrency }} </span>
            <span class="unit">{{ holding.initialCurrency.iso }}</span>
          </span>
        </li>
      }
        <!-- Profit Returned  -->
        <li>
          <label>Profit Returned</label>
          <span>
            <span class="value">{{ holding.totalProfitReturned | terraCurrency }} </span>
            <span class="unit">{{ holding.initialCurrency.iso }}</span>
          </span>
        </li>
      <!-- Total Distributed  -->
      <li>
        <label>Total Distributed</label>
        <span>
          <span class="value">{{ holding.totalCapitalReturned + holding.totalProfitReturned | terraCurrency }} </span>
          <span class="unit">{{ holding.initialCurrency.iso }}</span>
        </span>
      </li>
    </ul>
  </section>
</ng-container>
